import AbstractDriver from '../driver';

const ConsoleDriver = Object.create(AbstractDriver);

/**
 * Handle log messages and log them to the browser/nodejs console
 * @param  {number} level   The log level of the message
 * @param  {mixed}  message The log message to be logged
 * @param  {object} logger  The logger that handled the message
 */
ConsoleDriver.log = function (level, message, logger) {
  if (!('console' in window)) return;

  switch (level) {
    case logger.DEBUG: return console.debug(message);
    case logger.INFO: return console.info(message);
    case logger.WARN: return console.warn(message);
    case logger.ERROR:
    case logger.FATAL: return console.error(message);
  }
};

export { ConsoleDriver as default };
